import React, { useState, useEffect } from "react";
import SEOHead from "./SEOHead";
import { api } from "../services/api";
import "./UsefulLinks.css";

const UsefulLinks = () => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const data = await api.getUsefulLinks();
        setLinks(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching useful links:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLinks();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <SEOHead title="Loading Resources | Dr. Sunil Apsingi" noindex={true} />
        <div className="spinner-border text-teal" role="status">
          <span className="visually-hidden">Loading resources...</span>
        </div>
        <p className="text-muted mt-2 small">Loading patient resources...</p>
      </div>
    );
  }

  return (
    <section className="useful-links-section section-padding">
      <SEOHead
        title="Patient Resources & Clinical Orthopedic Links | Dr. Sunil Apsingi"
        description="Scientific orthopedic publications, medical society guidelines, and patient rehabilitation links curated by Dr. Sunil Apsingi."
        canonicalPath="/usefullinks"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Useful Links", path: "/usefullinks" },
        ]}
      />
      <div className="container">
        <div className="text-center mb-5">
          <span className="section-header-pill">
            <i className="fa-solid fa-link me-1"></i> Patient Guides
          </span>
          <h1 className="section-title-large">Useful Links & Clinical References</h1>
          <p className="section-subtitle-muted">
            Verified scientific orthopedic references, clinical societies, and patient recovery guidelines recommended by Dr. Sunil Apsingi.
          </p>
        </div>

        <div className="row g-4">
          {links.length > 0 ? (
            links.map((link, index) => {
              const descriptionText = link.description || link.discrption || "";
              return (
                <div key={link.id || index} className="col-lg-4 col-md-6">
                  <a
                    href={link.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="card-link-wrapper text-decoration-none"
                  >
                    <div className="resource-card medical-card h-100 p-4">
                      <div className="d-flex align-items-start gap-3">
                        <div className="resource-icon-box">
                          {link.img ? (
                            <img
                              src={link.img}
                              alt={link.title}
                              className="resource-icon-img"
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          ) : (
                            <i className="fa-solid fa-file-lines text-teal fs-4"></i>
                          )}
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="resource-title d-flex align-items-center justify-content-between mb-2">
                            <span>{link.title}</span>
                            <i className="fa-solid fa-arrow-up-right-from-square text-teal fs-6"></i>
                          </h5>
                          <p className="resource-desc text-muted small mb-0">
                            {descriptionText}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              );
            })
          ) : (
            <div className="col-12 text-center py-5">
              <p className="text-muted">No patient resources available at this time.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default UsefulLinks;